import OpenSeadragon, { Options } from "openseadragon";

export interface ExtendedOptions extends Options {
  toolbar?: string; // This is missing for some reason
  pixelsPerMeter?: number;
}

// @ts-ignore (avif if not a key of `formats`, but we know we can force it in)
OpenSeadragon.setImageFormatsSupported({ jpeg: true, jpg: true, avif: true });

export class ExtendedSeadragonViewer extends OpenSeadragon.Viewer {
  private readonly pixelsPerMeter?: number;

  constructor(options: ExtendedOptions) {
    super(options); // Can call super() since above code does not reference this
    this.pixelsPerMeter = options.pixelsPerMeter;
  }

  getPixelsPerMeter(): number | undefined {
    return this.pixelsPerMeter;
  }
}

const factoryFunction = function (
  options: ExtendedOptions
): ExtendedSeadragonViewer {
  return new ExtendedSeadragonViewer(options);
};

export default factoryFunction;
